/** Which sidebar item and submenu belong to a page, so the highlight follows the URL rather than the last click. */

export interface RouteNavKeys {
  /** Submenu keys to open; empty for a top-level item. */
  open: string[]
  selected: string
}

// Keyed by the page segment of `/app/{appId}/{segment}`; tabbed routes keep their own rules in appNavMenu.
export const ROUTE_NAV_KEYS: Record<string, RouteNavKeys> = {
  overview: { open: [], selected: 'overview' },
  integrate: { open: [], selected: 'integrate' },
  analytics: { open: [], selected: 'insights' },
  users: { open: ['manage'], selected: 'manage-users' },
  groups: { open: ['manage'], selected: 'manage-groups' },
  roles: { open: ['manage'], selected: 'manage-users-roles' },
  chats: { open: ['chats'], selected: 'chats-logs' },
  'conversation-explorer': { open: ['chats'], selected: 'chats-conversation-explorer' },
  'chat-features': { open: ['chats'], selected: 'chats-features' },
  'chat-settings': { open: ['chats'], selected: 'chats-settings' },
  widgets: { open: ['chats'], selected: 'chats-widgets' },
  calls: { open: ['calls'], selected: 'calls-logs' },
  'ai-agents': { open: ['ai-agent'], selected: 'ai-agents' },
  'notifications-logs': { open: ['Notifications'], selected: 'notifications-logs' },
  'notifications-legacy': { open: ['Notifications'], selected: 'notifications-legacy' },
  credentials: { open: ['application'], selected: 'application-credentials' },
  webhooks: { open: ['application'], selected: 'application-webhooks' },
  'webhooks-legacy': { open: ['application'], selected: 'application-webhooks-legacy' },
  members: { open: ['application'], selected: 'application-team-members' },
  'audit-logs': { open: ['application'], selected: 'application-audit-logs' },
  'plans-billing': { open: ['application'], selected: 'plans-billing' },
  general: { open: ['application'], selected: 'application-settings' },
}

/** `null` for a page with no entry here, e.g. an agent's own sub-pages, which use the agent menu. */
export function getRouteNavKeys(pathname: string): RouteNavKeys | null {
  const [, app, , segment, subPage] = pathname.split('/')
  if (app !== 'app' || !segment) return null
  if (segment === 'ai-agents' && subPage) return null
  return ROUTE_NAV_KEYS[segment] ?? null
}
